import * as React from 'react';

import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { AdfoxContextProvider, TAdfoxContextProviderProps } from '../../context/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'aside',
  place__DEPRECATED: 'CardKP',
  name__DEPRECATED: 'CardKP_Aside_TGB',
};
const P_PARAMS: TAdfoxContextProviderProps['pParams'] = { p1: 'dbfka', p2: 'fkhj' };
const SIZE: TAdfoxContextProviderProps['size'] = { width: '100%', height: 433 };

export const TgbAsideBannerContainer: React.FC = () => {
  return (
    <AdfoxContextProvider
      bannerPlace="aside"
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      size={SIZE}
      pParams={P_PARAMS}
    >
      <AdfoxBannerContainer />
    </AdfoxContextProvider>
  );
};
